var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"create_loading"}},[_vm._v("正在生成中("+_vm._s(parseInt(_vm.num))+"%)....")])}
var staticRenderFns = []

export { render, staticRenderFns }